import {
  DqSidePanel,
  DqSidePanelActions,
  DqSidePanelContent,
} from "@decentriq/components";
import { Divider } from "@mui/joy";
import { Fragment, memo } from "react";
import { MediaDataRoomVersionSwitch } from "features/mediaDataRoom/components";
import {
  type Audience,
  type AudienceAb,
  type AudienceV3,
} from "features/mediaDataRoom/models";
import AudienceAbDrawerActions from "./AudienceDrawerActions/AudienceAbDrawerActions";
import AudienceV3DrawerActions from "./AudienceDrawerActions/AudienceV3DrawerActions";
import AudienceDrawerDetails from "./AudienceDrawerDetails";
import AudienceDrawerToolbar from "./AudienceDrawerToolbar";

interface MediaDataRoomAudienceDrawerProps {
  open: boolean;
  onClose: () => void;
  audience: Audience | null;
}

const MediaDataRoomAudienceDrawer = memo<MediaDataRoomAudienceDrawerProps>(
  ({ onClose, open, audience }) => (
    <DqSidePanel.Floating onClose={onClose} open={open}>
      {audience ? (
        <Fragment>
          <AudienceDrawerToolbar audience={audience} />
          <Divider inset="context" />
          <DqSidePanelContent>
            <AudienceDrawerDetails audience={audience} />
          </DqSidePanelContent>
          <DqSidePanelActions>
            <MediaDataRoomVersionSwitch
              ab={<AudienceAbDrawerActions audience={audience as AudienceAb} />}
              v3={<AudienceV3DrawerActions audience={audience as AudienceV3} />}
            />
          </DqSidePanelActions>
        </Fragment>
      ) : null}
    </DqSidePanel.Floating>
  )
);
MediaDataRoomAudienceDrawer.displayName = "MediaDataRoomAudienceDrawer";

export default MediaDataRoomAudienceDrawer;
